import { render } from "./FluidColumn.vue?vue&type=template&id=d0ddd17a&scoped=true"
const script = {}

import "./FluidColumn.vue?vue&type=style&index=0&id=d0ddd17a&scoped=true&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ddd17a"]])

export default __exports__